import React from 'react'
import { Squeezy } from 'squeezy'
import {
  Container,
  TextTitle,
  TextBody,
  Icon,
  Expandable,
  State,
  Link
} from '@pmi/pmi-iqos-ds-react'
import {
  goTo,
  Routes,
  analytics,
  PaymentTypes,
  htmlTranslation
} from '@pmi/pmi-iqos-shared-react'
import {
  CheckoutProfileInfo,
  CheckoutStep1,
  CheckoutStep2
} from '@dcx-common/components'

const CheckoutSteps = ({
  allowStoringCard,
  toggleStep,
  isStepEnabled,
  isStepActive,
  enableNextStep,
  setStateProperty,
  handleCheckboxChange,
  handlePaymentMethodsChange,
  purchase,
  handleDeliveryOptionsUpdate,
  deliveryOptions,
  selectedPaymentMethodIndex,
  showSaveAsProfileAddress,
  toggleSaveAsProfileAddress,
  isDefaultAddressCheckboxDisabled,
  termsAndConds,
  isPurchaseEnabled,
  cart,
  translations,
  getSavedNewShippingAddress,
  contactInfo,
  defaultShippingAddress,
  defaultShippingAddressIsValid,
  hasAdyenPaymentMethod,
  tobaccoPassword,
  clearAdyenCheckoutForm,
  paymentMethods,
  shippingMethods,
  updateCheckoutDeliveryOptions,
  pickupRegions,
  pickupFailed,
  handleSearchPickupStores,
  pickupStoreList,
  pickupStoreListNumber,
  handleSelectShippingMethod,
  selectedShippingMethodIndex,
  handleSelectPickupStore,
  selectedPickupStore,
  pickupStoreListNoResult,
  loading,
  handleChangeNewShippingAddress,
  paymentMethodsIcons,
  toggleStorePaymentMethod,
  handleDeleteCreditCard,
  handleEditCreditCard,
  isPaymentIdSet,
  isSagawa,
  handleZipCodeNotEligibleForSagawa,
  line,
  coupons
}) => {
  const handleEditProfileClick = () => {
    analytics.checkoutEditCostumerInfo()
    goTo(Routes.profileAccount, true)
  }

  return (
    <Container pb={['10', '0']}>
      <Container pb="8" px={['8', '0']}>
        <Container
          display={Container.displays.flex}
          divider={[Container.dividers.top, Container.dividers.bottom]}
          justifyContent={Container.justifyContentValues.between}>
          <Container
            display={Container.displays.flex}
            alignItems={Container.alignItemsValues.center}
            pt={['6', '0']}
            pb="6">
            <Container pr="3">
              <Icon size={Icon.sizes.xs} image={Icon.images.user} />
            </Container>
            <TextTitle heading={TextTitle.headings.h6}>
              {translations.tk_registeredInfoTitle}
            </TextTitle>
          </Container>
          <Container
            display={Container.displays.flex}
            alignItems={Container.alignItemsValues.center}
            justifyContent={Container.justifyContentValues.end}
            pt={['6', '0']}
            pb="6">
            {!isSagawa && (
              <Link
                onClickHandler={handleEditProfileClick}
                underlined={false}
                data-testing="Checkout_Button_EditProfile">
                <Container
                  display={Container.displays.flex}
                  alignItems={Container.alignItemsValues.center}>
                  <Container pr="2">
                    <Icon size={Icon.sizes.xs} image={Icon.images.address} />
                  </Container>
                  <TextBody size={TextBody.sizes.s}>
                    {translations.tk_checkoutEditProfileButton}
                  </TextBody>
                </Container>
              </Link>
            )}
          </Container>
        </Container>

        <Container pt={['2', '6']}>
          <CheckoutProfileInfo
            translations={translations}
            contactInfo={contactInfo}
            showEmail
          />
        </Container>
        <Container pt="2">
          <TextBody
            size={TextBody.sizes.s}
            {...htmlTranslation(translations, 'tk_checkoutEmailDescription')}
          />
        </Container>
      </Container>
      <Squeezy
        isOpen={isStepActive(0)}
        id="1"
        render={() => (
          <Container id="step1Section" bg={Container.backgrounds.white}>
            <Container
              p="6"
              display={Container.displays.flex}
              alignItems={Container.alignItemsValues.center}
              divider={Container.dividers.bottom}
              onClickHandler={() => toggleStep(0)}>
              <Container
                fullWidth
                display={Container.displays.flex}
                alignItems={Container.alignItemsValues.center}>
                <Container pr="3">
                  <Icon size={Icon.sizes.xs} image={Icon.images.orders} />
                </Container>
                <TextTitle heading={TextTitle.headings.h6}>
                  {isSagawa
                    ? translations.tk_stepOneTileSagawa
                    : translations.tk_stepOneTile}
                </TextTitle>
              </Container>
              <Container>
                {isStepEnabled(1) ? (
                  <State state={State.states.valid} />
                ) : (
                  <Icon
                    size={Icon.sizes.xs}
                    image={
                      isStepActive(0)
                        ? Icon.images.chevronUp
                        : Icon.images.chevronDown
                    }
                  />
                )}
              </Container>
            </Container>
            <Expandable isOpen={isStepActive(0)}>
              <Container p={['4', '6']}>
                <CheckoutStep1
                  enableNextStep={enableNextStep}
                  defaultShippingAddress={defaultShippingAddress}
                  defaultShippingAddressIsValid={defaultShippingAddressIsValid}
                  showSaveAsProfileAddress={showSaveAsProfileAddress}
                  toggleSaveAsProfileAddress={toggleSaveAsProfileAddress}
                  isDefaultAddressCheckboxDisabled={
                    isDefaultAddressCheckboxDisabled
                  }
                  getSavedNewShippingAddress={getSavedNewShippingAddress}
                  setMainStateProperty={setStateProperty}
                  products={cart.products}
                  translations={translations}
                  hasTobacco={cart.hasTobacco}
                  shippingMethods={shippingMethods}
                  handleDeliveryOptionsUpdate={handleDeliveryOptionsUpdate}
                  deliveryOptions={deliveryOptions}
                  updateCheckoutDeliveryOptions={updateCheckoutDeliveryOptions}
                  pickupRegions={pickupRegions}
                  pickupFailed={pickupFailed}
                  handleSearchPickupStores={handleSearchPickupStores}
                  pickupStoreList={pickupStoreList}
                  pickupStoreListNumber={pickupStoreListNumber}
                  handleSelectShippingMethod={handleSelectShippingMethod}
                  selectedShippingMethodIndex={selectedShippingMethodIndex}
                  handleSelectPickupStore={handleSelectPickupStore}
                  selectedPickupStore={selectedPickupStore}
                  pickupStoreListNoResult={pickupStoreListNoResult}
                  preorder={cart.preorder}
                  loading={loading}
                  handleChangeNewShippingAddress={
                    handleChangeNewShippingAddress
                  }
                  isSagawa={isSagawa}
                  handleZipCodeNotEligibleForSagawa={
                    handleZipCodeNotEligibleForSagawa
                  }
                  line={line}
                  coupons={coupons}
                />
              </Container>
            </Expandable>
          </Container>
        )}
      />
      <Container pt={['2', '4']} />
      <Squeezy
        isOpen={isStepActive(1)}
        id="2"
        render={() => (
          <Container id="step2Section" bg={Container.backgrounds.white}>
            <Container
              p="6"
              display={Container.displays.flex}
              alignItems={Container.alignItemsValues.center}
              divider={Container.dividers.bottom}
              onClickHandler={() => toggleStep(1)}>
              <Container
                fullWidth
                display={Container.displays.flex}
                alignItems={Container.alignItemsValues.center}>
                <Container pr="3">
                  <Icon size={Icon.sizes.xs} image={Icon.images.cards} />
                </Container>
                <TextTitle
                  heading={TextTitle.headings.h6}
                  style={
                    isStepEnabled(1)
                      ? TextTitle.styles.normal
                      : TextTitle.styles.grayedout
                  }>
                  {paymentMethods[selectedPaymentMethodIndex].paymentType !==
                  PaymentTypes.ZERO_YEN
                    ? translations.tk_stepTwoTitle
                    : translations.tk_stepZeroYenTitle}
                </TextTitle>
              </Container>
              <Container>
                <Icon
                  size={Icon.sizes.xs}
                  image={
                    isStepActive(1)
                      ? Icon.images.chevronUp
                      : Icon.images.chevronDown
                  }
                />
              </Container>
            </Container>
            <Expandable isOpen={isStepActive(1)}>
              <CheckoutStep2
                products={cart.products}
                isOpen={isStepActive(1)}
                isPurchaseEnabled={isPurchaseEnabled}
                handleCheckboxChange={handleCheckboxChange}
                purchase={purchase}
                termsAndConds={termsAndConds}
                selectedPaymentMethodIndex={selectedPaymentMethodIndex}
                handlePaymentMethodsChange={handlePaymentMethodsChange}
                translations={translations}
                hasTobacco={cart.hasTobacco}
                tobaccoPassword={tobaccoPassword}
                hasAdyenPaymentMethod={hasAdyenPaymentMethod}
                setMainStateProperty={setStateProperty}
                clearAdyenCheckoutForm={clearAdyenCheckoutForm}
                paymentMethods={paymentMethods}
                phone={contactInfo.phone}
                loading={loading}
                paymentMethodsIcons={paymentMethodsIcons}
                allowStoringCard={allowStoringCard}
                toggleStorePaymentMethod={toggleStorePaymentMethod}
                handleDeleteCreditCard={handleDeleteCreditCard}
                handleEditCreditCard={handleEditCreditCard}
                isPaymentIdSet={isPaymentIdSet}
                isSagawa={isSagawa}
                line={line}
              />
            </Expandable>
          </Container>
        )}
      />
    </Container>
  )
}

export default CheckoutSteps
